import React from "react";
import MainLayouts from "../layout/MainLayouts";
import AboutHero from "../components/About/AboutHero";
import AboutContent from "../components/About/AboutContent";
import AboutProcess from "../components/About/AboutProcess";
import StatsBar2 from "./LandingPage/Component/StatsBar2";
import CTASession from "../components/About/CtaSession";
function About() {
  return (
    <MainLayouts>
      <AboutHero/>
      <AboutContent/>
      <div className="bg-[#F7F8F7">
       <StatsBar2/>
      </div>
      <AboutProcess/>
      <CTASession/>
      {/* <div className="innersection">
        <AboutTop />
      </div>

      <AboutSpecial /> */}

      {/* <Ambition /> */}
      {/* <Choose /> */}
      {/* <Advisor /> */}
      {/* <Gallery /> */}
      {/* <More /> */}
    </MainLayouts>
  );
}

export default About;
